// extracted by mini-css-extract-plugin
module.exports = {"categories":"BoxLaunch_categories__1P0Iu","subjects":"BoxLaunch_subjects__IAAps","last":"BoxLaunch_last__MHDUx","content":"BoxLaunch_content__2-o3u","box":"BoxLaunch_box__1KiTH"};